<template>
   <BannerList />
</template>

<script>

// @ is an alias to /src
import BannerList from "@/components/BannerList.vue";

export default {
name: "BannerLists",
components: {
   BannerList,
},
};
</script>
